import { FriendSuggestionModel } from "@/features/user";
import { api } from "@/services/api";
import {
  MessageModel,
  NotificationViewModel,
  RecipientModel,
} from "@/types/chat";

const chatApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRecipients: build.mutation<RecipientModel[], void>({
      query: (payload) => {
        return {
          url: "api/Chat/GetRecipients",
          method: "post",
          data: payload,
        };
      },
    }),
    getMessages: build.mutation<MessageModel[], any>({
      query: (payload) => {
        return {
          url: "api/Chat/GetMessages",
          method: "post",
          data: payload,
        };
      },
    }),
    addEditMessage: build.mutation<MessageModel[], any>({
      query: (payload) => {
        return {
          url: "api/Chat/AddEditMessage",
          method: "post",
          data: payload,
        };
      },
    }),
    markMessageAsRead: build.mutation<any, any>({
      query: (payload) => {
        return {
          url: "api/Chat/MarkMessageAsRead",
          method: "post",
          data: payload,
        };
      },
    }),
    getNotificationCount: build.mutation<number, number>({
      query: (payload) => {
        return {
          url: "api/Chat/GetNotificationCount",
          method: "post",
          data: payload,
        };
      },
    }),
    getNotifications: build.mutation<NotificationViewModel[], number>({
      query: (payload) => {
        return {
          url: "api/Chat/GetNotifications",
          method: "post",
          data: payload,
        };
      },
    }),
    markNotificationsAsRead: build.mutation<any, void>({
      query: (payload) => {
        return {
          url: "api/Chat/MarKNotificationAsRead",
          method: "post",
          data: payload,
        };
      },
    }),
    getFriendSuggestions: build.query<FriendSuggestionModel[], void>({
      query: (payload) => {
        return {
          url: "api/Chat/GetFriendSuggestions",
          method: "get",
          data: payload,
        };
      },
    }),
    getFriendRequests: build.query<FriendSuggestionModel[], void>({
      query: (payload) => {
        return {
          url: "api/Chat/GetFriendRequests",
          method: "get",
          data: payload,
        };
      },
    }),
    sendFriendRequest: build.mutation<any, any>({
      query: (payload) => {
        return {
          url: "api/Chat/SendFriendRequest",
          method: "post",
          data: payload,
        };
      },
    }),
    acceptRejectFriendRequest: build.mutation<any, any>({
      query: (payload) => {
        return {
          url: "api/Chat/AcceptRejectFriendRequest",
          method: "post",
          data: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRecipientsMutation,
  useGetMessagesMutation,
  useAddEditMessageMutation,
  useMarkMessageAsReadMutation,
  useGetNotificationCountMutation,
  useGetNotificationsMutation,
  useMarkNotificationsAsReadMutation,
  useLazyGetFriendSuggestionsQuery,
  useLazyGetFriendRequestsQuery,
  useSendFriendRequestMutation,
  useAcceptRejectFriendRequestMutation,
} = chatApi;

export default chatApi;
